import {kebabCase} from 'lodash'
import {OpsOrderType} from 'types/orderTypes'
import {ProductGroupType} from 'types/productTypes'
import type {QueryAddressType} from 'actions/propertyActions'
import {isNotNullOrUndefinedOrEmptyString} from './tsServices'

export const getPropertyUrlByAddress = (address: QueryAddressType) => {
  if (!address) {
    return ''
  }

  // remove falsy values that are not allowed by URLSearchParams constructor,
  // such as apartmentNumber, which can be "" or undefined, as a benefit this
  // narrows the types from string | null | undefined to just string
  const cleanedAddress: Record<string, string> = Object.fromEntries(
    Object.entries(address as Object).filter(([_key, value]) =>
      isNotNullOrUndefinedOrEmptyString(value)
    )
  )
  const addressQuery = new URLSearchParams(cleanedAddress).toString()
  return `/property-overview?${addressQuery}`
}

export const getOrderDetailsLink = (
  productGroup: ProductGroupType,
  opsOrderId: OpsOrderType['opsOrderId']
): string => `/orders/${kebabCase(productGroup?.toLowerCase())}/${opsOrderId}`
